<template>
  <div id="MessageList">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
      <eb-search
        @search-click="searchData"
        slot="search"
      />
    </eb-header>
    <div class="order-box">
      <eb-type-filter
        class="screen"
        @getTypeFilterData="getTypeFilterData"
        :typeFilterData="typeFilterData"
      />
      <div>
        <el-button
          @click="checkDel"
          style="margin-top: 20px;"
          class="el-button el-button eb-button-orange eb-button-small el-button--default"
        >批量删除</el-button>
        <el-button
          @click="readAllMessage"
          style="margin-top: 20px;width:106px;"
          class="el-button el-button eb-button-orange eb-button-small el-button--default"
        >全部标记已读</el-button>
      </div>
    </div>
    <div class="table table-box eb-table">
      <el-table
        :data="pageData"
        :stripe="true"
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChange"
      >
        <el-table-column
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          property='messageContent'
          label="消息内容"
          sortable="custom"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.operType === '8'">
              {{scope.row.messageContent}}
            </template>
            <template v-else-if="scope.row.operType">
              <template v-if="scope.row.stauts === '1'">
                <a
                  @click="hrefMesage(scope.row)"
                  href="javascript:void(0)"
                  class="a-font-red"
                >{{scope.row.messageContent}}</a>
              </template>
              <template v-else>
                <a
                  @click="hrefMesage(scope.row)"
                  href="javascript:void(0)"
                  class="a-font-black"
                >{{scope.row.messageContent}}</a>
              </template>
            </template>
            <template v-else>
              {{scope.row.messageContent}}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          property='createTime'
          label="创建时间"
          width="200"
          sortable="custom"
        >
          <template slot-scope="scope">
            {{scope.row.createTime|dateTimeStandardFormat}}
          </template>
        </el-table-column>
        <el-table-column
          property='stauts'
          label="状态"
          width="100"
          sortable="custom"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.stauts === '2' ">已读</template>
            <template v-else>
              <a
                @click="viewMesage(scope.row.id)"
                href="javascript:void(0)"
                class="a-font-red"
              >查看</a>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <eb-pagination
        v-if="recordsTotal"
        @current-change="onPageChange"
        :current-page.sync="listRequestData.pageNumber"
        :page-size="listRequestData.length"
        :total="recordsTotal"
      />
    </div>
  </div>
</template>

<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import ebTypeFilter from '@/components/common/eb-type-filter';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import { listMessage, delAllMessage, readAllMessage, viewMesage, readOne } from '@/services/message-service';
import { getProjectDetailByIdMsg, getProjectByIdMsg } from '@/services/proj/pro-project-service';
import { getBidtProjectDetailByIdMsg, getProjectById } from '@/services/proj/bid-project-service';
import { getDepartmentById } from '@/services/org/depart-service';
import EventBus from '@/plugins/event-bus';
export default {
  name: 'MessageList',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    ebTypeFilter,
    ebPagination
  },
  data() {
    return {
      loading: true,
      pageData: null,
      recordsTotal: null,
      user: this.$store.state.user.userInfo,
      typeFilterData: [
        { text: '全部', content: '' },
        { text: '系统', content: 0 },
        { text: '公司', content: 1 },
        { text: '项目', content: 2 }
      ],
      listRequestData: {
        messageType: '',
        messageContent: '',
        length: 10,
        start: 0,
        pageNumber: 1,
        columnIndex: '3',
        orderAdesc: 'desc'
      },
      multipleSelection: []
    };
  },
  created() {
    this.initList();
    EventBus.$emit('getMessageCount', '');
  },
  methods: {
    // 初始化消息列表
    async initList() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await listMessage(this.listRequestData);
        if (data.returnCode === '01' || data.returnCode === '00') {
          this.pageData = data.data;
          this.recordsTotal = data.recordsTotal;
        } else {
          this.$message.error('获取项目列表失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    // 初始化参数
    resetListRequestData() {
      this.listRequestData.start = 0;
      this.listRequestData.pageNumber = 1;
      this.listRequestData.messageContent = '';
      this.listRequestData.messageType = '';
    },
    // 校验是否选择消息
    checkDel() {
      let msgIdLength = this.multipleSelection.length;
      if (msgIdLength === 0) {
        this.$message.error('请选择要删除的消息');
      } else {
        this.deleteMessageConfirm();
      }
    },
    // 删除消息确认
    deleteMessageConfirm: function() {
      this.$ebConfirm('是否删除?')
        .then(() => {
          this.delAllMessage();
        })
        .catch(() => {});
    },
    // 删除消息重新加载项目
    async delAllMessage() {
      let messageIds = '';
      this.multipleSelection.forEach(function(element, index) {
        let messageId = element.id;
        messageIds += messageId + ',';
      });
      try {
        let { data } = await delAllMessage(messageIds);
        if (data.returnCode === '01') {
          this.$message.success('删除成功.');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.initList();
      EventBus.$emit('getMessageCount', '');
    },
    // 全部标记为已读
    async readAllMessage() {
      try {
        let { data } = await readAllMessage();
        if (data.returnCode === '01') {
          this.$message.success('标记成功.');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.initList();
      EventBus.$emit('getMessageCount', '');
    },
    // 查看消息
    async viewMesage(msgId) {
      try {
        await viewMesage(msgId);
      } catch (error) {
        this.$message.error(error.message);
      }
      this.initList();
      EventBus.$emit('getMessageCount', '');
    },
    // 消息跳转
    async hrefMesage(rowData) {
      let params = rowData.params;
      let id = rowData.id;
      let stauts = rowData.stauts;
      let operType = rowData.operType;
      let messageType = rowData.messageType;
      let roleId = this.user.roleid + '';
      try {
        if (stauts === '1') {
          if (messageType === '2' && roleId === '2') {
            this.$message.error('您无权限访问此功能，请切换用户角色后操作！');
            return;
          }
          // 查看一条信息
          let { data } = await readOne(id);
          if (data.returnCode === '01') {
            this.initList();
            EventBus.$emit('getMessageCount', '');
            this.messageUrl(params, operType, messageType);
          }
        } else {
          this.messageUrl(params, operType, messageType);
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 构造消息跳转逻辑
    async messageUrl(params, operType, messageType) {
      let roleId = this.user.roleid + '';
      if (messageType === '2') {
        if (roleId === '2') {
          this.$message.error('您无权限访问此功能，请切换用户角色后操作！');
          return;
        }
        if (operType === '1' || operType === '3') {
          let paramsData = {
            projectId: params
          };
          let { data } = await getProjectByIdMsg(paramsData);
          if (data.returnCode === '01') {
            this.$router.push('/projpro/quotation/summary/' + params);
          } else {
            this.$message.error('项目已撤回或不存在，您无法查看报价!');
          }
        }
        if (operType === '2') {
          if (params !== '' && params !== null) {
            sessionStorage.setItem('searchContent', params);
          }
          this.$router.push('/projpro/quoted/list');
        }
        if (operType === '4' || operType === '16') {
          let { data } = await getProjectDetailByIdMsg(params);
          if (data.returnCode === '05') {
            this.$message.error('项目已截止或不存在，您无法参与报价!');
          } else if (data.returnCode === '00') {
            this.$message.error(data.message);
          } else {
            this.$router.push('/projpro/demand/' + params + '/' + this.user.userid);
          }
        }
        if (operType === '20') {
          if (params !== '' && params !== null) {
            sessionStorage.setItem('searchContent', params);
          }
          this.$router.push('/projpro/quoted/list');
        }
      }
      if (messageType === '3') {
        if (roleId === '2') {
          this.$message.error('您无权限访问此功能，请切换用户角色后操作！');
          return;
        }
        if (operType === '1' || operType === '3') {
          let paramsData = {
            projectId: params
          };
          let { data } = await getProjectById(paramsData);
          if (data.returnCode === '01') {
            this.$router.push('/projbid/quotation/summary/' + params);
          } else {
            this.$message.error('项目已撤回或不存在，您无法查看报价!');
          }
        }
        if (operType === '2') {
          if (params !== '' && params !== null) {
            sessionStorage.setItem('searchContent', params);
          }
          this.$router.push('/projbid/quoted/list');
        }
        if (operType === '4' || operType === '16') {
          let { data } = await getBidtProjectDetailByIdMsg(params);
          if (data.returnCode === '05') {
            this.$message.error('项目已截止或不存在，您无法参与报价!');
          } else if (data.returnCode === '00') {
            this.$message.error(data.message);
          } else {
            this.$router.push('/projbid/demand/' + params + '/' + this.user.userid);
          }
        }
        if (operType === '20') {
          if (params !== '' && params !== null) {
            sessionStorage.setItem('searchContent', params);
          }
          this.$router.push('/projbid/quoted/list');
        }
      }

      if (operType === '6' || operType === '7') {
        this.$router.push('/user/view');
      }
      if (operType === '11' || operType === '12') {
        this.$router.push('/org/register/list');
      }
      if (operType === '5') {
        window.open(`${location.origin}/api/docs?biddoc01`);
      }
      if (operType === '13') {
        this.$router.push('/org/realname/list');
      }
      if (operType === '14') {
        this.$router.push('/org/detail');
      }
      if (operType === '15') {
        this.$router.push('/org/edit/');
      }
      if (operType === '17') {
        this.$router.push('/busi/opptypush/list');
      }
      if (operType === '18') {
        this.$router.push('/payment/list');
      }
      if (operType === '19') {
        this.$router.push('/user/org/detail');
      }
      if (operType === '10') {
        if (params !== '' && params !== null) {
          let { data } = await getDepartmentById(params);
          if (data.returnCode === '01') {
            this.$router.push('/org/detail/' + params);
          } else {
            this.$message.error('机构不存在或已删除!');
          }
        }
      }
      if (roleId !== '1') {
        // if (operType === '20') {
        //   if (params === '1') {
        //     this.$router.push('/projpro/quoted/list');
        //   }
        //   if (params === '2') {
        //     this.$router.push('/projbid/quoted/list');
        //   }
        // }
        if (operType === '21') {
          this.$router.push('/payment/list');
        }
      } else {
        if (operType === '20' || operType === '21') {
          this.$router.push('/sys/notarization');
        }
      }
      if (operType === '22') {
        this.$router.push('/sys/invoice');
      }
    },
    // 点击消息类型
    getTypeFilterData: function(data) {
      this.resetListRequestData();
      this.listRequestData.messageType = data;
      this.initList();
    },
    // 点击搜索
    searchData: function(data) {
      this.resetListRequestData();
      this.listRequestData.messageContent = data;
      this.initList();
    },
    // 分页
    onPageChange(pageNum) {
      let pageRow = (pageNum - 1) * this.listRequestData.length;
      this.listRequestData.start = pageRow;
      this.listRequestData.pageNumber = pageNum;
      this.initList();
    },
    // 复选框选择
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 排序
    handleSortChange(orderDescData) {
      let prop = orderDescData.prop;
      let order = orderDescData.order;
      switch (prop) {
        case 'messageContent':
          this.listRequestData.columnIndex = '2';
          break;
        case 'createTime':
          this.listRequestData.columnIndex = '3';
          break;
        case 'stauts':
          this.listRequestData.columnIndex = '4';
          break;
        default:
          return '';
      }
      switch (order) {
        case 'descending':
          this.listRequestData.orderAdesc = 'desc';
          break;
        case 'ascending':
          this.listRequestData.orderAdesc = 'asc';
          break;
        default:
          return '';
      }
      this.initList();
    }
  }
};
</script>

<style scoped lang="less">
.order-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px 49px 15px 51px;
}
.list-box {
}
.card-box {
  margin-bottom: 33px;
}
.noSearchText {
  font-size: 21px;
  margin-top: 20px;
  text-align: center;
}
.table {
  padding: 20px 20px;
  max-width: 100%;
  margin-bottom: 20px;
}

.a-font-red {
  color: red;
  text-decoration: underline !important;
}
.a-font-black {
  color: #595959;
  text-decoration: underline !important;
}
</style>
